import { FC } from 'react';

import { Vortex } from '../ui/vortex';
import { BentoGrid, BentoGridItem, BentoGridItemProps } from '../ui/bento-grid';
import { SkillItem } from './types/skill';

interface SkillsProps {
  data: (SkillItem & BentoGridItemProps)[];
}

export const Skills: FC<SkillsProps> = ({ data }) => {
  const items: (SkillItem & BentoGridItemProps)[] = data.map((skillItem) => ({
    title: (
      <ul className="flex flex-wrap gap-2 text-white font-light text-sm">
        {skillItem.skills.map((skill, index) => (
          <li
            key={index}
            className="rounded-md border border-white/[0.08] bg-white/[0.04] px-3 py-1 text-white/80 transition-colors duration-200 hover:border-purple/40 hover:bg-purple/10 hover:text-white"
          >
            {skill}
          </li>
        ))}
      </ul>
    ),
    description: (
      <h3 className="text-lg font-semibold mb-3 text-purple">{skillItem.category}</h3>
    ),
    ...skillItem,
  }));

  return (
    <section id="skills">
      <div className="w-full rounded-md flex items-center justify-center h-64 overflow-hidden">
        <Vortex
          backgroundColor="transparent"
          containerClassName="w-full h-full"
          className="flex items-center flex-col justify-center w-full h-full"
        >
          <h1 className="heading">
            My hard
            {' '}
            <span className="text-purple">skills.</span>
          </h1>
        </Vortex>
      </div>
      <BentoGrid className="w-full">
        {items.map((item) => (
          <BentoGridItem
            key={item.id}
            {...item}
          />
        ))}
      </BentoGrid>
    </section>
  );
};
